import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

let locale = 'th'
const en = ['en-US', 'en', 'en-GB', 'en-AU', 'en-CA', 'en-NZ']

if (localStorage.getItem('locale')) {
  locale = localStorage.getItem('locale')
} else if (en.includes(navigator.language)) {
  locale = 'en'
} 

if (!localStorage.getItem('locale')) {
  localStorage.setItem('locale', locale);
}

export default new VueI18n({
  locale,
  fallbackLocale: locale,
  messages: loadLocaleMessages()
})



// WEBPACK FOOTER //
// ./src/i18n.js